(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('BIAResponsibilityKeyStaffModalController', Controller);

    Controller.$inject = ['$scope', '$q', 'esbEmployeeService', 'pagerService', 'biaResponsibilityService', 'notificationService'];

    function Controller($scope, $q, searchService, pagerService, biaResponsibilityService, notificationService) {

        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {};

        $scope.availableKeyPersons = [];
        $scope.selectedKeyPersons = _.cloneDeep($scope.boxContext.BIAKeyPersons);
        $scope.keyPersonsToDelete = [];
        $scope.ctrlCtxt.isSearching = false;

        // Init Pager
        $scope.pager = pagerService.newPager({ numberOfItemsPerPage: 5 });
        $scope.pager.updatePagerFromItems($scope.availableKeyPersons);

        // Search Key Persons
        $scope.searchPersons = function () {
            var searchTerm = $scope.ctrlCtxt.searchTerm;
            if (_.isUndefined(searchTerm) || searchTerm.length < 2) {
                $scope.availableKeyPersons = [];
                $scope.pager.updatePagerFromItems($scope.availableKeyPersons);
                return;
            }
            $scope.ctrlCtxt.isSearching = true;

            searchService
                .searchEmployees(searchTerm)
                .then(function (foundPersons) {
                    $scope.availableKeyPersons =
                        _.differenceWith(foundPersons, $scope.selectedKeyPersons, function(foundPerson, selectedKeyPerson) {
                            return foundPerson.ItemPersonID === selectedKeyPerson.Person.ItemPersonID;
                        });
                    $scope.pager.updatePagerFromItems($scope.availableKeyPersons);
                })
                .finally(function () {
                    $scope.ctrlCtxt.isSearching = false;
                });
        };

        // Add Key Person
        $scope.addKeyPerson = function (employee) {
            var toUndelete = _.remove($scope.keyPersonsToDelete, {PersonID: employee.ItemPersonID});

            // Was in persons to delete, re-add in available
            if (toUndelete.length > 0) {
                toUndelete = toUndelete[0];

                // Reset Role info
                delete toUndelete.RoleID;
                delete toUndelete.Role;
                $scope.selectedKeyPersons.unshift(toUndelete);

            } else {
                $scope.selectedKeyPersons.unshift({
                    PersonID: employee.ItemPersonID,
                    Person: employee,
                    BIAResponsibilityID: $scope.boxModel.BIAResponsibilityID,
                });
            }

            // Remove from search results
            _.remove($scope.availableKeyPersons, {ItemPersonID: employee.ItemPersonID});
            $scope.pager.updatePagerFromItems($scope.availableKeyPersons);
        };

        // Remove BIA Key Person
        $scope.removeKeyPerson = function (biaKeyPerson) {
            var toRemove = _.remove($scope.selectedKeyPersons, {PersonID: biaKeyPerson.PersonID});
            toRemove = toRemove[0];

            // To Delete from Server
            if (toRemove.BIAKeyPersonID) {
                $scope.keyPersonsToDelete = _.concat($scope.keyPersonsToDelete, toRemove);
            }
        };

        // Save
        $scope.save = function () {
            // Warning: order is important as it may change the selected systems (add before removing)

            var promiseChain = $q.when();

            // Chain all Key Persons to Update
            _.each($scope.selectedKeyPersons, function (keyPerson) {

                if (keyPerson.BIAKeyPersonID) {
                    promiseChain = promiseChain.then(function () {
                        return biaResponsibilityService
                            .updateKeyPerson(
                                $scope.boxModel.BIAProfileID,
                                $scope.boxModel.BIAResponsibilityID,
                                keyPerson);
                    });
                } else {
                    promiseChain = promiseChain.then(function () {
                        return biaResponsibilityService
                            .createKeyPerson(
                                $scope.boxModel.BIAProfileID,
                                $scope.boxModel.BIAResponsibilityID,
                                keyPerson);
                    });
                }
            });

            // Chain all Key Persons to Delete
            _.each($scope.keyPersonsToDelete, function (toDelete) {

                promiseChain = promiseChain.then(function () {
                    return biaResponsibilityService
                        .deleteBIAKeyPerson(
                            $scope.boxModel.BIAProfileID,
                            $scope.boxModel.BIAResponsibilityID,
                            toDelete.BIAKeyPersonID);
                });
            });

            promiseChain.then(function () {
                notificationService.notify('All changes have been successfully saved');

                $scope.onClose();
            });
        };
    }
})();
